import React from 'react';
import { Icon, Popup } from 'semantic-ui-react'
import moment from 'moment'
import TrainingRequirementPopup from './training_requirement_popup'

import { calculateFields } from '../../helpers/training_requirement_helpers';

export default class TrainingRequirementFormatter extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      value: props.value
    }
  }

  componentWillMount(){
    var trainingRequirement = {...this.props.value}
    if (!['needed', 'not-needed'].includes(trainingRequirement.status)) {
      this.updateTrainingIfOverdue(trainingRequirement);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.value !== nextProps.value){
      var value = {...nextProps.value}
      value.original_frequency = value.frequency
      this.setState({
        value: value
      })
    }
  }

  setTrainingRequirement = (value) => {
    this.setState({
      value: value
    })
  }

  formatDate() {
    const { date_completed, status, due_date } = this.state.value
    if(status === 'needed')
    {
      return <div>&nbsp;</div>
    }

    if(status === 'not-needed' && !date_completed) {
      return 'X'
    }

    return (
      <div>
        <div>{moment(new Date(date_completed)).format("DD-MMM-YYYY")}</div>
        { due_date && <div className='due-date'>(Exp-{moment(new Date(due_date)).format("DD-MMM-YYYY")})</div> }
      </div>
    )
  }

  setAsNeeded() {
    var value = this.state.value
    value.date_completed = ''
    value.rowIndex = this.props.rowIndex
    value.customized_frequency = false
    value.customized_due_date = false
    calculateFields(value, this.setTrainingRequirement)
    this.props.onTrainingUpdate(value)
  }

  setAsNotNeeded() {
    var value = this.state.value
    value.date_completed = 'X'
    value.rowIndex = this.props.rowIndex
    value.customized_frequency = false
    value.customized_due_date = false
    calculateFields(value, this.setTrainingRequirement)
    this.props.onTrainingUpdate(value)
  }

  toggleTrainingRequirementPopup = (show) => {
    this.setState({
      showTrainingRequirementPopup: show
    })
  }

  openTrainingRequirementPopup = () => {
    this.toggleTrainingRequirementPopup(true)
  }

  closeTrainingRequirementPopup = () => {
    this.toggleTrainingRequirementPopup(false)
  }

  updateTrainingDetails = (value) => {
    this.setState({value, showTrainingRequirementPopup: false})
    this.props.onTrainingUpdate(value)
  }

  trainingRequirementPopup = () => {
    if (!this.state.showTrainingRequirementPopup) return;

    const { value: training_requirement } = this.state;
    const { trainingModule: training_module } = this.props;

    if (!training_module) return console.error(`Cannot find a training module with id=${training_requirement.module_id}.`);

    return (
      <TrainingRequirementPopup 
        defaultFrequency={training_module.default_frequency}
        trainingRequirement={training_requirement}
        updateTrainingDetails={this.updateTrainingDetails}
        onClose={ this.closeTrainingRequirementPopup }
      />
    )
  }

  updateTrainingStatus(status) {
    var value = this.state.value
    value.status = status
    value.rowIndex = this.props.rowIndex
    this.setTrainingRequirement(value)
    this.props.onTrainingUpdate(value)
  }

  updateTrainingIfOverdue = (trainingRequirement) => {
    var dueDateMoment, isOverdue, isDueInThreeMonths, threeMonthsBeforeDueDate;
  
    if (trainingRequirement.customized_due_date) {
      dueDateMoment = moment(trainingRequirement.due_date).endOf('day')
    } else {
      dueDateMoment = moment(trainingRequirement.date_completed).endOf('day').add(trainingRequirement.frequency, 'years')
    }

    threeMonthsBeforeDueDate = dueDateMoment.clone().subtract(3, 'months')
    isDueInThreeMonths = moment().isSame(threeMonthsBeforeDueDate, 'day') || 
                        (moment().endOf('day').isAfter(threeMonthsBeforeDueDate) && moment().endOf('day').isBefore(dueDateMoment.clone()));
    isOverdue = moment().endOf('day').isAfter(dueDateMoment) || moment().isSame(dueDateMoment, 'day')
    if (isDueInThreeMonths && trainingRequirement.status !== 'due-in-3-months') {
      this.updateTrainingStatus('due-in-3-months')
    } else if (isOverdue && trainingRequirement.status !== 'overdue') {
      this.updateTrainingStatus('overdue')
    }
  }

  render() {
    const { traineeTeams=[] } = this.props;
    const { tag_list=[], category } = this.props.trainingModule || {};
    const { status, date_completed } = this.state.value;
    const statusList = ['needed', 'completed', 'overdue', 'due-in-3-months'];;
    const isRemoved = ['not-needed', null].includes(status);
    const isAdded = statusList.includes(status);
    const isRequiredByTeam = traineeTeams.some(tag=> tag_list.includes(tag));
    const datePickerClass = this.props.disabled ? 'datepicker-visible disabled' : 'datepicker-visible';
    const isRequiredForAllStaff = category === 'all';

    return (
      <div className={'custom-datepicker legends-training-' + this.state.value.status } onClick={evt=>evt.stopPropagation()}>
        {
          (isRequiredForAllStaff && status === 'not-needed') &&
          <div className='requirement-desc'>
            <Popup
              className='requirement-desc-popup'
              trigger={<Icon name='minus circle'/>}
              position='top left'
              content='Training is Required for All Staff and has been removed Manually.'
            >
            </Popup>
          </div>
        }
        {
          (!isRequiredForAllStaff && !isRequiredByTeam && isAdded) &&
          <div className='requirement-desc'>
            <Popup
              className='requirement-desc-popup'
              trigger={<Icon name='plus circle'/>}
              position='top left'
              content='Training is Not Required by Team and has been added Manually.'
            >
            </Popup>
          </div>
        }
        {
          (!isRequiredForAllStaff && isRequiredByTeam && isRemoved) &&
          <div className='requirement-desc'>
            <Popup
              className='requirement-desc-popup'
              trigger={<Icon name='minus circle'/>}
              position='top left'
              content='Training is Required by Team and has been removed Manually.'
            >
            </Popup>
          </div>
        }
        {
          (!isRequiredForAllStaff && !isRequiredByTeam && isRemoved && date_completed) &&
          <div className='requirement-desc'>
            <Popup
              className='requirement-desc-popup'
              trigger={<Icon name='info circle'/>}
              position='top left'
              content='Training is currently Not Required but has been previously completed.'
            >
            </Popup>
          </div>
        }
        <div className={datePickerClass}>
          { this.formatDate() }
          <Icon name='window minimize' className='hidden'/>
        </div>
        {
          !this.props.disabled &&
          <div className='datepicker-hidden'>
            {
              (this.state.value.status !== 'needed') &&
              <Popup trigger={<Icon name='minus' circular inverted bordered link onClick={ () => this.setAsNeeded() }/>} content='Clear content' position='bottom left' basic />
            }
            {
              (this.state.value.status !== 'not-needed') &&
              <Popup trigger={<Icon name='times' inverted circular bordered link onClick={ () => this.setAsNotNeeded() }/>} content='Mark as Training Not-Needed' position='bottom left' basic />
            }
            {
              <Popup
                className='training-requirement-popup-wrapper'
                trigger={ <Icon name='calendar alternate' circular inverted bordered style={{cursor:'pointer'}}/> }
                content= { this.trainingRequirementPopup() }
                onOpen={ this.openTrainingRequirementPopup }
                onClose={ this.closeTrainingRequirementPopup }
                position="bottom left"
                basic
                flowing
                verticalOffset={-10}
                on='click'
              />
            }
            
          </div>
        }
      </div>
    )

  }
}



// WEBPACK FOOTER //
// ./src/views/components/training_requirement_formatter.js